import React, { ReactElement, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../../../../store';
import { NewAdmissionState } from '../../../../../../store/models/newAdmissionModel';
import * as actions from '../../../../../../store/actions/fileAction';
import OtpInput from 'react-otp-input';
import { CheckboxValueType } from 'antd/lib/checkbox/Group';
import Checkbox, { CheckboxChangeEvent } from 'antd/lib/checkbox';
import './consentModal.less';
import {
  setAadharNo, setEnableMobileOTP, setEncryptedTxn, setEnableAadhaarOTP,
  setMobileNo, setMobileOnScreen, setMobileOTP,
  setToggleClick, setMobileVerification, setHealthVaultEnable, setEnableAadhar, setHealthVaultDocumentUpload,
  setUserPresent,
  setUsersNotFound,
  setTxnId,
  setAadhaarOTP,
  setUserProfiles,
  setAadharVerficationSuccess,
  setTempProfile,
  setDocumentList,
  setCheckedList,
  setCheckAllDocs,
  setShowShareDocumentOptionsModal,
  setLinkAbhaClick,
  createHealthBankUser,
  fetchHealthBankUserProfile,
  setShowAbhaLinkModal,
  setHealthbankUserSignupOption,
  setDocumentUploadSuccess,
} from '../../../../../../store/actions/newAdmissionAction';
import { centeredNotification } from '../../../../../../utils/utility';
import { Button, Col, Form, Input, Modal, Radio, Result, Row, Space } from 'antd';
import { FormInputMobile } from '../../../../../../shared/components/crmFormElement/FormInput';
import { RadioChangeEvent } from 'antd/lib/radio';

const ConsentModal = (): ReactElement => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const {
    toggleClick, enableMobileOtp, mobileNumberValue, mobileOnScreen, mobileVerification, healthVaultEnable, enableAadhar, enableAadhaarOtp,
    userPresent, usersNotFound, healthVaultDocumentUpload, userProfilesArray, aadharVerificationSuccess,
    tempProfile, uploadedFiles, uploadedFileList, checkedFileList, checkAll, showShareDocumentOptionsModal,
    healthbankUserSignupOption, aadharNumberValue, documentUploadSuccess,
  } = useSelector((state: RootState): NewAdmissionState => state.newAdmission);
  const { claimDetails } = useSelector((state: RootState): any => state.admissionDetails);

  const [userName, setUserName] = useState('');
  const [, setProfileSelected] = useState(false);
  const [OTP, setOTP] = useState('');
  const [AADHAROTP, setAadharOTP] = useState('');
  const [loading, setIsLoading] = useState(false);
  const [, setFileName] = useState('');
  const [selectedShareDocOption, setShowShareDocumentOption] = useState<string>('');
  const [selectedSignupUserOption, setSelectedSignupUserOption] = useState<string>('');
  const onCheck = (list: CheckboxValueType[]): any => {
    dispatch(setCheckedList(list));
    dispatch(setCheckAllDocs(list.length === uploadedFileList?.length));
  };

  const onCheckAllChange = (e: CheckboxChangeEvent): any => {
    if (e?.target?.checked) {
      form?.setFieldsValue({ checkboxGroup: uploadedFileList?.map(({ documentGuid }: any): any => documentGuid) });
      dispatch(setCheckedList(e?.target?.checked ? uploadedFileList?.map((ele: any): any => ele?.documentGuid) : []));
    } else {
      form?.setFieldsValue({ checkboxGroup: [] });
      dispatch(setCheckedList([]));
    }
    dispatch(setCheckAllDocs(e?.target?.checked));
  };
  const getMobileOtpNo = (data: any): void => {
    const { isUserPresent, encryptedToken, isSuccess, errors = [] } = data || {};
    if (isSuccess) {
      setIsLoading(false);
      dispatch(setEncryptedTxn(encryptedToken));
      dispatch(setUserPresent(isUserPresent));
      dispatch(setEnableMobileOTP(true));
      dispatch(setMobileOnScreen(false));
      dispatch(setMobileVerification(true));
      setOTP('');
    } else {
      onCancelToggle();
      centeredNotification(errors.join(',\n'));
    }
  };
  const verifyMobileOtpNumber = (data: any): void => {
    const { userDetail = {}, isSuccess, errors = [], isOTPVerified } = data || {};
    if (isSuccess && isOTPVerified) {
      setIsLoading(false);
      getUploadedDocuments();
      dispatch(setUserProfiles(userDetail));
      dispatch(setEnableMobileOTP(false));
      dispatch(setMobileVerification(false));
      if (userDetail) {
        dispatch(setHealthVaultEnable(true));
        dispatch(setUsersNotFound(false));
      }
    } else {
      setIsLoading(false);
      dispatch(setEnableMobileOTP(false));
      dispatch(setMobileVerification(false));
      dispatch(setMobileOnScreen(false));
      centeredNotification(errors?.join(',\n'));
      onCancelToggle();
    }
  };

  const getCreateUserPayload = (aadhar: string | undefined, prefilledData: any): any => {
    const unmaskedNumber = mobileNumberValue.split(' ').join('').replace('+91', '');
    const { name, gender = '', birthdate = '', email = '', photo = '', healthIdNumber } = prefilledData || {};
    let formattedDob: any = '';
    const tempSplitDob = (birthdate ?? '').split('-');
    if (birthdate) {
      formattedDob = tempSplitDob[2] + '-' + tempSplitDob[1] + '-' + tempSplitDob[0] + 'T00:00:00.000';
    }
    return {
      'userName': name ?? '',
      'firstName': name?.split(' ')[0] ?? '',
      'lastName': '',
      'email': email ?? '',
      'adhaar': aadhar ?? '',
      'isActive': true,
      'dateOfBirth': formattedDob || null,
      'phoneNo': unmaskedNumber,
      'gender': gender,
      'isPropertyLoaded': true,
      'healthId': healthIdNumber,
      'kycPhoto': photo,
    };
  };

  const handleAadharVerificationFailure = (): void => {
    const payload = getCreateUserPayload('', {
      name: claimDetails?.patientName ?? '',
    });
    if (enableAadhar) {
      dispatch(setEnableAadhar(false));
    }
    dispatch(
      createHealthBankUser(payload, onSuccessCreateUser, onFailCreateUser),
    );
  };

  const verifyAadhaarOtpNumber = (data: any): void => {
    const { name, isSuccess, errorMessage = [] } = data || {};
    // handle api fail scenario , isSuccess false .on error
    // Scenarios : 1. API Fail with 4XX,5XX status code, 2. Api sucess with error message , 3. Api success with wrong/null aadhar KYC data
    if (errorMessage) {
      handleAadharVerificationFailure();
      return;
    }
    if (isSuccess) {
      if (selectedSignupUserOption === 'AADHAR_SIGNUP_FLOW') {
        // If Aadhar api fails to return user KYC info, create a guest user.
        if (!data || !data?.name) {
          handleAadharVerificationFailure();
          return;
        }
        const payload = getCreateUserPayload(aadharNumberValue, data);
        dispatch(
          createHealthBankUser(payload, onSuccessCreateUser, onFailCreateUser),
        );
        return;
      }
      setIsLoading(false);
      dispatch(setEnableAadhaarOTP(false));
      setUserName(name);
      dispatch(setAadharVerficationSuccess(true));
      setTimeout((): any => dispatch(setAadharVerficationSuccess(false)), 1000);
      setTimeout((): any => dispatch(setHealthVaultDocumentUpload(true)), 1200);
    } else {
      setIsLoading(false);
      dispatch(setEnableAadhaarOTP(false));
      handleAadharVerificationFailure();
    }
  };
  const uploadDocuments = (data: any): void => {
    const { fileName, isSuccess, errors = [] } = data || {};
    if (isSuccess) {
      setIsLoading(false);
      dispatch(setAadharVerficationSuccess(false));
      dispatch(setHealthVaultDocumentUpload(false));
      setFileName(fileName);
      dispatch(setDocumentUploadSuccess(true));
      setTimeout((): any => {
        dispatch(setDocumentUploadSuccess(false));
        onCancelToggle();
      }, 800);
    } else {
      onCancelToggle();
      centeredNotification(errors.join(',\n'));
    }
  };

  const getAadharOtpNo = (data: any): void => {
    const { isSuccess, errors = [], txnId } = data || {};
    if (isSuccess) {
      setIsLoading(false);
      dispatch(setEnableAadhaarOTP(true));
      dispatch(setEnableAadhar(false));
      dispatch(setTxnId(txnId));
      setAadharOTP('');
    } else {
      setIsLoading(false);
      centeredNotification(errors.join(',\n'));
      handleAadharVerificationFailure();
    }
  };

  const onSuccessFetchHealthBankUser = (profileDeatils1: any): void => {
    dispatch(setUserProfiles({ 'userProfiles': profileDeatils1 }));
    dispatch(setTempProfile(profileDeatils1?.[0] ?? []));
    dispatch(setHealthVaultDocumentUpload(true));
    dispatch(setEnableAadhaarOTP(false));
  };

  const onFailsFetchHealthBankUser = (): void => {
    console.error('Failed to fetch user data');
  };

  const onSuccessCreateUser = (newHealthBankUserId2: string | undefined): any => {
    setIsLoading(false);
    dispatch(fetchHealthBankUserProfile(newHealthBankUserId2, onSuccessFetchHealthBankUser, onFailsFetchHealthBankUser));

  };
  const onFailCreateUser = (): any => {
    centeredNotification('Failed to Register user,Please try again!');
    onCancelToggle();
  };

  const onCancelToggle = (): any => {
    setIsLoading(false);
    dispatch(setToggleClick(false));
    dispatch(setMobileOnScreen(false));
    dispatch(setEnableMobileOTP(false));
    dispatch(setMobileVerification(false));
    dispatch(setHealthVaultEnable(false));
    dispatch(setEnableAadhaarOTP(false));
    dispatch(setEnableAadhar(false));
    dispatch(setUsersNotFound(false));
    dispatch(setHealthVaultDocumentUpload(false));
    dispatch(setCheckedList([]));
    setProfileSelected(false);
    form?.setFieldsValue({ mobile: '' });
    form?.setFieldsValue({ aadharNo: '' });
    setOTP('');
    setAadharOTP('');
    dispatch(setDocumentList([]));
    dispatch(setShowShareDocumentOptionsModal(false));
    dispatch(setDocumentUploadSuccess(false));
  };
  const generateOtp = (): any => {
    setIsLoading(true);
    dispatch(setMobileNo(form.getFieldsValue()?.mobile));
    dispatch(actions.getMobileOtp({ getMobileOtpNo }));
  };
  const handleSignupOptionClick = (): void => {
    dispatch(setHealthbankUserSignupOption(selectedSignupUserOption));
    if (selectedSignupUserOption === 'GUEST_SIGNUP_FLOW') {
      setIsLoading(true);
      const payload = getCreateUserPayload('', { name: claimDetails?.patientName ?? '' });
      dispatch(createHealthBankUser(payload, onSuccessCreateUser, onFailCreateUser));
    } else if (selectedSignupUserOption === 'AADHAR_SIGNUP_FLOW') {
      dispatch(setEnableAadhar(true));
    }
  };

  const handleSelectShareOption = (e: RadioChangeEvent): void => {
    setShowShareDocumentOption(e?.target?.value ?? '');
  };
  const handleSelectSignupOption = (e: RadioChangeEvent): void => {
    setSelectedSignupUserOption(e?.target?.value ?? '');
  };
  const handleSelectUser = (e: RadioChangeEvent): void => {
    const selectedBenef = userProfilesArray['userProfiles'].find((userProfile: any): any => userProfile?.id === e?.target?.value);
    dispatch(setTempProfile(selectedBenef));

  };

  const handleShareProceedShareDoc = (): void => {
    dispatch(setShowShareDocumentOptionsModal(false));
    if (selectedShareDocOption === 'ABHA_FLOW') {
      onCancelToggle();
      dispatch(setLinkAbhaClick(true));
      dispatch(setShowAbhaLinkModal(true));
    } else if (selectedShareDocOption === 'HEALTHBANK_FLOW') {
      dispatch(setMobileOnScreen(true));
    }
  };
  const generateAadharOtp = (): any => {
    setIsLoading(true);
    dispatch(
      setAadharNo(
        healthbankUserSignupOption === 'AADHAR_SIGNUP_FLOW'
          ? form.getFieldsValue()?.aadharNo?.replaceAll(' ', '')
          : tempProfile?.adhaarNo?.replaceAll(' ', ''),
      ),
    );
    dispatch(actions.getAadharOtp({ getAadharOtpNo }));
  };
  const verifyOtpGenerated = (): any => {
    setIsLoading(true);
    dispatch(setMobileOTP(OTP));
    dispatch(actions.verifyMobileOtp({ verifyMobileOtpNumber }));

    if (userPresent) {
      dispatch(setUsersNotFound(false));
    } else {
      dispatch(setUsersNotFound(true));
    }
  };
  const verifyAadharOtpGenerated = (): any => {
    setIsLoading(true);
    dispatch(setAadhaarOTP(AADHAROTP));
    dispatch(actions.verifyAadhaarOtp({ verifyAadhaarOtpNumber }));

  };
  const proceedDocumentUpload = (): any => {
    setIsLoading(true);
    dispatch(actions.uploadDoc({ uploadDocuments }));
  };

  const handleChange = (data: string): any => {
    setOTP(data);
  };
  const onValue = (data: string): any => {
    setAadharOTP(data);
  };
  const proceedHealthVault = (): any => {
    setIsLoading(true);
    dispatch(setHealthVaultEnable(false));
    if (!tempProfile?.aadhar) {
      setIsLoading(false);
      dispatch(setHealthVaultDocumentUpload(true));
      dispatch(setUsersNotFound(false));
      setProfileSelected(true);
      dispatch(setMobileNo(tempProfile?.phoneNumber));
      return;
    }
    if (userPresent) {
      setIsLoading(false);
      generateAadharOtp();
      dispatch(setUsersNotFound(false));
      setProfileSelected(true);
      dispatch(setMobileNo(tempProfile?.phoneNumber));
    } else {
      setIsLoading(false);
      dispatch(setEnableAadhar(false));
      dispatch(setUsersNotFound(true));
      setProfileSelected(false);
    }
  };

  const shareDocumentOptionsConfig = [
    {
      label: 'Link health records with ABHA only',
      value: 'ABHA_FLOW',
    },
    {
      label: 'Link health records with IHX Health Bank',
      value: 'HEALTHBANK_FLOW',
    },
  ];
  const healthBankUserCreationConfig = [
    {
      label: 'Share With Aadhaar',
      value: 'AADHAR_SIGNUP_FLOW',
    },
    {
      label: 'Share Without Aadhaar',
      value: 'GUEST_SIGNUP_FLOW',
    },
  ];

  const getUploadedDocuments = (): any => {
    uploadedFiles?.map((ele: any, index: number): any => {
      const temp = {};
      temp['documentName'] = ele?.name;
      temp['documentGuid'] = ele?.docPath || ele?.response?.uploadedDetails?.map((element: any): any => {
        if (element?.fileGuid !== undefined && element?.fileGuid !== null) {
          temp['documentGuid'] = element?.fileGuid;
        }
      });
      temp['documenttype'] = ele?.fileType || ele?.type;
      uploadedFileList?.push(temp);
    });
    dispatch(setDocumentList(uploadedFileList));
  };

  const getTitle = (): any => {
    // Note : Switch case wont work properly , And please add any flag with lowest scope on the top
    if (healthVaultDocumentUpload) {
      return <p className="font-title">Select Health Record</p>;
    } else if (healthVaultEnable) {
      return <p className="font-title">Select the profile </p>;
    } else if (enableAadhaarOtp || enableMobileOtp) {
      return <p className="font-title">Enter OTP</p>;
    } else if (mobileOnScreen) {
      return <p className="font-title">Enter your 10 digit mobile number</p>;
    } else if (enableAadhar) {
      return <p className="font-title">SHARE HEALTH RECORD VIA ADHAAR OTP</p>;
    } else if (usersNotFound || showShareDocumentOptionsModal) {
      return <p className="font-title">Select Share Option</p>;
    }

    return <p className="font-title">Share Documents</p>;
  };

  return (
    <Form form={form}>
      <Modal className="modal-size" zIndex={999999999999999}
        title={getTitle()}
        centered={true}
        visible={toggleClick}
        onCancel={(): any => onCancelToggle()}
        footer={false}
        maskClosable={false}>
        {showShareDocumentOptionsModal &&
          <Form.Item name="shareOptions" rules={[{ required: true, message: 'Share option is required!' }]}>
            <Radio.Group onChange={handleSelectShareOption}>
              <Space direction="vertical">
                {
                  shareDocumentOptionsConfig.map((ele: any): any => (
                    <Radio key={ele.value} value={ele.value}> {ele.label} </Radio>
                  ))
                }
              </Space>
            </Radio.Group>
          </Form.Item>
        }
        {mobileOnScreen &&
          <>

            <FormInputMobile
              detail={{
                disabled: false,
                key: 'mobile',
                size: 18,
                rightFooterText: null,
                isEditableInDetail: true,
              }} />
          </>}
        {enableMobileOtp &&
          <OtpInput
            onChange={handleChange}
            value={OTP}
            containerStyle="otp-container-size"
            inputStyle="otp-size"
            numInputs={6}
            separator={<span className="margin-space" />} />
        }
        {healthVaultEnable &&
          <div>
            <p>Select the profile on IHX Health Bank to link the health record </p>
            <Form.Item name="profileOptions" rules={[{ required: true, message: 'Please select a Profile!' }]}>
              <Radio.Group onChange={handleSelectUser}>
                <Space direction="vertical">
                  {
                    userProfilesArray['userProfiles']?.map((profile: any): ReactElement => (
                      <Radio key={profile?.id} value={profile?.id}> {profile?.name || 'User'} </Radio>
                    ))
                  }
                </Space>
              </Radio.Group>
            </Form.Item>
          </div>
        }
        {
          enableAadhar && healthbankUserSignupOption === 'AADHAR_SIGNUP_FLOW' &&
          <><p className="font-toggle-modal">
            Enter your Adhaar number</p>
            <Form.Item
              name="aadharNo"
            >
              <Input style={{ width: '100%' }} />
            </Form.Item>
          </>}
        {usersNotFound && !healthVaultDocumentUpload && !enableMobileOtp && !enableAadhar && !enableAadhaarOtp && !documentUploadSuccess &&
          <Form.Item name="signupOptions" rules={[{ required: true, message: 'Please create a user!' }]}>
            <Radio.Group onChange={handleSelectSignupOption}>
              <Space direction="vertical">
                {
                  healthBankUserCreationConfig.map((ele: any): any => (
                    <Radio key={ele.value} value={ele.value}> {ele.label} </Radio>
                  ))
                }
              </Space>
            </Radio.Group>
          </Form.Item>
        }
        {
          enableAadhaarOtp &&
          <><p className="font-toggle-modal">Enter the OTP to verify aadhar details sent on mobile number linked to aadhar.</p>
            <OtpInput
              onChange={onValue}
              value={AADHAROTP}
              containerStyle="otp-container-size"
              inputStyle="otp-size"
              numInputs={6}
              separator={<span className="margin-space" />} />
          </>}
        {documentUploadSuccess &&
          <Result
            status="success"
            title={`The health records are successfully shared to Health Bank`}
          />}
        {aadharVerificationSuccess &&
          <Result
            status="success"
            title={`Aadhar details successfully validated for ${userName} profile.`}
          />}
        {healthVaultDocumentUpload &&
          <>
            {uploadedFileList?.length ? <Form.Item
              name="shareAll">
              <Checkbox className="mb-0" onChange={onCheckAllChange}
                checked={checkAll}>
                Select all
              </Checkbox>
            </Form.Item> :
              <p className="font-toggle-modal">No Documents available to share</p>
            }

            <Form.Item name="checkboxGroup">
              <Checkbox.Group value={checkedFileList} onChange={onCheck}>
                <Row gutter={24}>
                  {uploadedFileList?.map((ele: any): any => (
                    <Col span={24} key={ele?.documentGuid}>
                      <Checkbox value={ele?.documentGuid}>
                        <span className="labelStyle">{ele?.documentName}</span>
                      </Checkbox>
                    </Col>
                  ))}
                </Row>
              </Checkbox.Group>
            </Form.Item>
          </>
        }
        <Col md={24} className="text-center">
          {/* Button For share ABHA or healthbank otion*/}
          {
            showShareDocumentOptionsModal ?
              <div className="healthVaultButtons">
                <Button disabled={selectedShareDocOption === ''} type="primary" htmlType="submit"
                  onClick={handleShareProceedShareDoc} loading={loading}>
                  Proceed
                </Button>
              </div>
              :
              mobileVerification ?
                <div className="healthVaultButtons">
                  {/* Button For Mobile Number*/}
                  <Button type="primary" htmlType="submit" onClick={verifyOtpGenerated} loading={loading}>
                    Next
                  </Button>
                </div> :
                (toggleClick && !healthVaultEnable && !usersNotFound && !enableAadhar && !enableAadhaarOtp &&
                  !healthVaultDocumentUpload && !aadharVerificationSuccess && !documentUploadSuccess) ?
                  <div className="healthVaultButtons">
                    <Button type="primary" htmlType="submit"
                      onClick={generateOtp} loading={loading}>
                      Next
                    </Button>
                  </div> :
                  healthVaultEnable ?
                    <div className="healthVaultButtons">
                      <Button type="primary" htmlType="submit" onClick={proceedHealthVault} loading={loading}>
                        Confirm Linking
                      </Button>
                    </div>
                    :
                    !enableAadhar && usersNotFound && !healthVaultDocumentUpload && !enableAadhaarOtp ?
                      <div className="healthVaultButtons">
                        <Button type="primary" htmlType="submit" danger={true} onClick={handleSignupOptionClick} loading={loading}>
                          Next
                        </Button>
                      </div> :
                      enableAadhar && !healthVaultDocumentUpload && healthbankUserSignupOption === 'AADHAR_SIGNUP_FLOW' &&
                        !enableAadhaarOtp ?
                        <div className="healthVaultButtons">
                          <Button type="primary" htmlType="submit" danger={true} onClick={generateAadharOtp} loading={loading}>
                            Next
                          </Button> </div> :
                        !enableAadhar && enableAadhaarOtp ?
                          <div className="healthVaultButtons">
                            <Button type="primary" htmlType="submit" danger={true} onClick={verifyAadharOtpGenerated} loading={loading}>
                              Verify Aadhar OTP
                            </Button></div> :
                          healthVaultDocumentUpload && uploadedFileList?.length ?
                            <div className="healthVaultButtons"> <Button type="primary" htmlType="submit"
                              danger={true} onClick={proceedDocumentUpload} loading={loading}>
                              Proceed
                            </Button>
                            </div>
                            : <></>
          }
        </Col>
      </Modal>
    </Form >
  );
};
export default ConsentModal;
